import React from 'react';
import { siteContent } from '../data/mock';

const Footer = () => {
  const { footer } = siteContent;

  return (
    <footer className="site-footer" data-testid="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="footer-brand-name">{footer.brand}</h3>
            <p className="footer-tagline">{footer.tagline}</p>
          </div>

          <div className="footer-divider"></div>

          <div className="footer-bottom-centered">
            <p className="footer-copyright">{footer.copyright}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
